import Api, { baseURL } from "../Api"

const BASE = `${baseURL("v2")}/{departamento}/indicadores/analises`

export default {
  async situacoes(params) {
    return Api.get(`${BASE}/situacoes`, params)
  },
  async situacoesPorMeses(params) {
    return Api.get(`${BASE}/situacoes-por-meses`, params)
  },
  async analistasPorMesses(params) {
    return Api.get(`${BASE}/analistas-por-meses`, params)
  },
}
